import { ArrowStyleTypes } from 'widgets/Lines/common/CommonLine.types';

import { LineEndConfig } from '../LineWidget.types';

/**
 * Const to multiply strokeWidth to get line padding so that line doesn't get cut off at the end
 */
const DEFAULT_LINE_END_PADDING_CONST = 2;
const LINE_END_PADDING_CONST_MAP: { [key in ArrowStyleTypes]?: number } = {
  [ArrowStyleTypes.none]: 0,
  [ArrowStyleTypes.line]: 0,
  [ArrowStyleTypes.outlineCircle]: 2.6,
  [ArrowStyleTypes.outlineDiamond]: 2.5,
  [ArrowStyleTypes.outlineBasic]: 2.8,
  [ArrowStyleTypes.lineArrow]: 1.5,
};

/**
 * Default config to pass into <marker> and <path> elements for line ends
 */
const DEFAULT_LINE_END_CONFIG: LineEndConfig = {
  markerProps: {
    viewBox: '0 0 10 10',
    refX: 10,
    refY: 5,
  },
  pathProps: {},
};

/**
 * Default multiplier to user for stroke width of the <path /> element used
 * for rendering the line ends.
 * May be used if need to make the line ends bigger or smaller relative to the line.
 */
const DEFAULT_STROKE_MULTIPLIER = 1;

/**
 * Optional config to pass into <marker> and <path> elements for line ends
 * If arrow style not specified, will use DEFAULT_LINE_END_CONFIG
 */
const LINE_END_CONFIG: {
  [key in ArrowStyleTypes]?: LineEndConfig;
} = {
  [ArrowStyleTypes.outlineBasic]: {
    markerProps: {
      viewBox: '0 0 26 26',
      refX: 26,
      refY: 13,
    },
    pathProps: {
      strokeWidth: 5,
      fill: 'transparent',
    },
  },
  [ArrowStyleTypes.lineArrow]: {
    markerProps: {
      viewBox: '0 0 14 14',
      refX: 14,
      refY: 7,
    },
    pathProps: {
      strokeWidth: 2.5,
      fill: 'transparent',
      strokeLinejoin: 'round',
      strokeLinecap: 'round',
    },
    strokeMultiplier: 2,
  },
};

export {
  LINE_END_PADDING_CONST_MAP,
  DEFAULT_LINE_END_PADDING_CONST,
  LINE_END_CONFIG,
  DEFAULT_LINE_END_CONFIG,
  DEFAULT_STROKE_MULTIPLIER,
};
